import { render, staticRenderFns } from "./StudentNewPage.vue?vue&type=template&id=5a8eac7b&scoped=true"
import script from "./StudentNewPage.vue?vue&type=script&lang=js"
export * from "./StudentNewPage.vue?vue&type=script&lang=js"
import style0 from "./StudentNewPage.vue?vue&type=style&index=0&id=5a8eac7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8eac7b",
  null
  
)

export default component.exports